import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Noise } from './Animations';
import { HaloBanner } from './HaloBanner';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-picus-bg text-picus-text font-sans" data-id="element-294">
      <Noise data-id="element-295" />
      <HaloBanner data-id="element-296" />
      <Navbar data-id="element-297" />
      <main className="flex-grow" data-id="element-298">{children}</main>
      <Footer data-id="element-299" />
    </div>;
}